import React from 'react';

function Button({ children, onClick, type = 'button', variant = 'primary', ...props }) {
  const className = `btn btn-${variant}`;
  
  return (
    <button 
      className={className} 
      type={type} 
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
}

export default Button;
